module.exports = __webpack_public_path__ + "img/30.01c175c4.gif";